<template>
  <el-dialog
    :title="isEdit ? '编辑活动' : '添加活动'"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="100px"
      size="small"
    >
      <el-form-item label="序号" prop="sortNum">
        <el-input
          v-model.number="formData.sortNum"
          placeholder="请输入序号"
          type="number"
        />
      </el-form-item>
      <el-form-item label="活动页名称" prop="activityName">
        <el-input
          v-model="formData.activityName"
          placeholder="请输入活动页名称"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button type="primary" size="small" @click="handleSubmit">
        保 存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addActivity, updateActivity } from "@/api/bannerManage";
export default {
  name: "AddActivityDlg",

  data() {
    return {
      visible: false,
      isEdit: false, // 新增编辑状态标识
      formData: {
        id: "", // 新增id字段，编辑时使用
        sortNum: "",
        activityName: "",
      },
      rules: {
        sortNum: [
          { required: true, message: "请输入序号", trigger: "blur" },
          { type: "number", message: "序号必须为数字", trigger: "blur" },
        ],
        activityName: [
          { required: true, message: "请输入活动页名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    // 打开弹窗
    publicOpen(row) {
      this.visible = true;
      this.isEdit = !!row;
      this.formData.id = ""; // 重置id，新增时不需要
      this.$nextTick(() => {
        this.$refs.form?.resetFields();
        if (row) {
          // 编辑状态，设置表单数据
          this.formData = {
            id: row.id,
            sortNum: row.sortNum,
            activityName: row.activityName,
          };
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false;
      this.isEdit = false;
      this.$refs.form?.resetFields();
    },

    // 提交表单
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            updateActivity(this.formData).then(() => {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.$emit("refresh"); // 触发父组件刷新数据
              this.handleClose();
            });
          } else {
            addActivity(this.formData).then(() => {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.$emit("refresh"); // 触发父组件刷新数据
              this.handleClose();
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
}
</style>
